<template>
    <div ref="keepInView">
        <p
            v-if="label != null"
            class="text-14 pb-1 transition-all duration-300 ease-in-out"
            :class="[disabled ? 'text-grey-600' : [dark ? 'text-white': 'text-grey-900']]"
        >
            {{ $help.capitalizeFirstLetter(label) }}
        </p>

        <!-- max-w-[300px] -->

        <!-- :class="[[inputClass, error != false ? 'border-error' : ''], [dark ? 'bg-black text-white border-grey-800/20' : 'border-grey-500 bg-grey'], [disabled ? 'disabled' : '']]" -->
        <DropdownV2
            class="relative"
            :class="{ error: error != false }"
            buttonCSS="relative"
            ref="dropdown"
            :isSelectMenu="false"
            :preventButtonClick="true"
            :menuClass="['w-full', menuClass]"
            position="right"
            :disabled="disabled"
            @dropdown="moveToTop"
        >
            <template #button="{ open, toggle }">
                <div
                    class="input-group"
                    :class="[
                        inputClass,
                        {
                            'border-grey-500': !disabled && error == false,
                            error: error != false,
                            disabled: disabled,
                            dark: dark,
                        },
                    ]"
                >
                    <input
                        ref="input"
                        v-model="lValue"
                        :name="name"
                        :placeholder="placeholder"
                        :tabindex="tabIndex"
                        class="w-full h-full input -mt-px"
                        type="text"
                        @keydown="dateIgnoreKeys"
                        @keyup="dateKeyup"
                        :disabled="disabled"
                        @click.prevent
                    />

                    <slot name="right" />

                    <!-- $nextTick(() => $refs.input.focus()) -->

                    <button
                        class="h-full pr-3 flex items-center justify-center z-10"
                        :class="[dark ? 'icon-hover-dark' : 'icon-hover']"
                        type="button"
                        :disabled="disabled"
                        @click.stop="
                            () => {
                                toggle()
                            }
                        "
                    >
                        <IconCalendar class="w-4.5 h-4.5 shrink-0" />
                    </button>
                </div>
            </template>

            <template #menu="{ open, activeDirection }">
                <div
                    ref="dateBox"
                    :class="[
                        activeDirection == 'bottom' ? 'border-b-0' : 'border-t-0',
                        dark ? 'bg-dark-grey-300 border-dark-grey-500' : 'border-grey-500 bg-white',
                    ]"
                    class="border w-full py-4"
                >
                    <div class="flex justify-between px-4">
                        <button class="flex items-center" type="button" @click="view = 'year'" v-if="view == 'day'">
                            <p class="font-hero font-bold text-17 pr-2" :class="[dark ? 'text-white' : '']">
                                {{ $moment(month, format).format('MMMM YYYY') }}
                            </p>

                            <IconArrowDown class="stroke-grey-900 w-4 h-4" />
                        </button>

                        <div v-else class="font-hero font-bold text-17 pr-2">Select {{ view }}</div>

                        <div class="flex w-12 justify-between pt-1" v-if="view != 'month'">
                            <button class="w-4.5" :class="[dark ? 'icon-hover-dark' : 'icon-hover']" type="button" @click="minus">
                                <IconArrowLeft class="w-4.5 h-4.5" />
                            </button>
                            <button class="w-4.5" :class="[dark ? 'icon-hover-dark' : 'icon-hover']" type="button" @click="add">
                                <IconArrowRight class="w-4.5 h-4.5" />
                            </button>
                        </div>
                    </div>

                    <div class="grid grid-cols-7 mt-3 px-[20px] gap-2 mx-[-7px]" v-if="view == 'day'">
                        <p v-for="title in titles" class="font-medium text-grey-900 text-14 text-center">
                            {{ title }}
                        </p>
                    </div>

                    <div class="mx-[-7px] overflow-hidden px-3" v-if="view == 'day'">
                        <div class="shrink-0 grow-0 w-full grid grid-cols-7 mt-2 gap-2 px-2"
                            :class='{
                                "text-white": dark
                            }'
                        >
                            <template v-for="date in dates">
                                <button
                                    v-if="date.date != -1"
                                    :class="[
                                        dark
                                            ? {
                                                  'bg-black': lValue == date.date,
                                                  'text-grey-300': date.before || date.after,
                                                  'border border-dark-grey-500 bg-dark-grey-500 rounded-full': date.today && lValue != date.date,
                                              }
                                            : {
                                                  'bg-black text-white': lValue == date.date,
                                                  'text-grey-900': date.before || date.after,
                                                  'bg-black text-white font-semibold rounded-full': date.today && lValue != date.date,
                                              },
                                    ]"
                                    :disabled="date.before || date.after"
                                    class="w-[30px] h-[30px] text-14 text-center m-auto"
                                    type="button"
                                    @click="setDate(date.date)"
                                >
                                    {{ date.day }}
                                </button>

                                <div v-else />
                            </template>
                        </div>
                    </div>

                    <div class="grid grid-cols-3 mt-3 px-2 gap-4" v-if="view == 'year'">
                        <button
                            class="h-8 text-grey-900 text-14"
                            type="button"
                            @click="
                                () => {
                                    view = 'month'
                                    month = $moment(month, format).subtract(8, 'Year').add(y, 'Year').startOf('month')
                                }
                            "
                            :class="{
                                'bg-black text-white rounded-tl-[8px] rounded-br-[8px]':
                                    $moment(month, format).subtract(8, 'Year').add(y, 'Year').format('YYYY') == $moment().format('YYYY'),
                            }"
                            v-for="y in 12"
                        >
                            {{ $moment(month, format).subtract(8, 'year').add(y, 'year').format('YYYY') }}
                        </button>
                    </div>

                    <div class="grid grid-cols-3 mt-3 px-2 gap-4" v-if="view == 'month'">
                        <button
                            class="h-8 text-grey-900 text-14"
                            type="button"
                            @click="
                                () => {
                                    view = 'day'
                                    month = $moment(month, format)
                                        .set('month', y - 1)
                                        .startOf('month')
                                }
                            "
                            :class="{
                                'bg-black text-white rounded-tl-[8px] rounded-br-[8px]':
                                    $moment(month, format)
                                        .startOf('year')
                                        .add(y - 1, 'Month')
                                        .format('MMMM YYYY') == $moment().format('MMMM YYYY'),
                            }"
                            v-for="y in 12"
                        >
                            {{
                                $moment(month, format)
                                    .startOf('year')
                                    .add(y - 1, 'Month')
                                    .format('MMMM')
                            }}
                        </button>
                    </div>

                    <div v-if="apply" class="grid grid-cols-1 gap-4 px-2 pt-4">
                        <button
                            class="bg-black hover:black-on-white text-white font-medium h-10 text-13"
                            data-close
                            type="button"
                            :disabled="lValue == null"
                        >
                            {{ doneButton }}
                        </button>

                        <!-- <button
							class="border border-black text-black font-medium h-10 text-13"
							data-close
							type="button"
							@click="lValue = oValue"
						>
							Go back
						</button> -->
                    </div>
                </div>
            </template>
        </DropdownV2>

        <Error :error="error" :name="name" :errorScrollTo="errorScrollTo" />
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        label: { default: null, type: String },
        value: String,
        inputClass: String,
        apply: { default: false, type: Boolean },
        dark: { default: false, type: Boolean },
        placeholder: {
            type: String,
            default: 'Select date',
        },
        format: {
            type: String,
            default: 'DD/MM/YYYY',
        },
        emitFormat: {
            type: [String, Boolean],
            default: false,
        },
        min: {
            type: [String, Number],
            default: null,
        },
        max: {
            type: [String, Number],
            default: null,
        },
        tabIndex: {
            type: Number,
            default: 0,
        },
        menuClass: { type: [Object, String, Array], default: null },
        doneButton: { type: String, default: 'Done' },
        errorName: { type: String, default: false },
        disabled: { type: Boolean, default: false },
        errorScrollTo: { type: [String, Boolean], default: false },
    },

    emits: ['update:value'],

    data() {
        return {
            // dates: null,
            lValue: this.value != null ? this.$moment(this.value, this.format).format(this.format) : null,
            oValue: this.value != null ? this.$moment(this.value, this.format).format(this.format) : null,
            month: this.value != null ? this.$moment(this.value, this.format).startOf('month') : this.$moment().startOf('month'),
            titles: ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'],
            translate: 0,
            ease: false,
            width: 0,
            view: 'day',
        }
    },

    mounted: function () {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    beforeUnmount: function () {
        window.removeEventListener('resize', this.handleResize)
    },

    methods: {
        add() {
            if (this.view == 'year') {
                this.month = this.$moment(this.month).add(12, 'Year')
            } else if (this.view == 'month') {
                this.month = this.$moment(this.month).add(1, 'Year')
            } else {
                this.month = this.$moment(this.month).add(1, 'M')
            }
        },

        minus() {
            if (this.view == 'year') {
                this.month = this.$moment(this.month).subtract(12, 'Year')
            } else if (this.view == 'month') {
                this.month = this.$moment(this.month).subtract(1, 'Year')
            } else {
                this.month = this.$moment(this.month).subtract(1, 'M')
            }
        },

        setDate(date) {
            this.lValue = date
            this.$emit('update:value', this.emitFormat ? this.$moment(this.lValue, this.format).format(this.emitFormat) : this.lValue)

            if (!this.apply) {
                this.$refs.dropdown.toggle()
            }
        },

        handleResize(event) {
            if (this.$refs.dateBox) {
                this.width = this.$refs.dateBox.clientWidth
            }
        },

        dateIgnoreKeys(event) {
            let last = event.target.value[event.target.value.length - 1]
            let doubleSlash = last == '/' && event.keyCode == 191

            if ([32, 13].indexOf(event.keyCode) > -1 || doubleSlash) {
                event.preventDefault()
            }
        },

        dateKeyup(event) {
            // console.log(event);
            if (event.code == 'Enter' || event.keyCode == 32) {
                event.preventDefault()
                return this.lValue
            }

            if (event.code == 'Backspace' || event.target.value == null) {
                return this.lValue
            }

            let value = event.target.value
            let len = value.length
            let dd = value.split('/')[0]
            let mm = value.split('/')[1]
            let yyyy = value.split('/')[2]

            let intDD = parseInt(dd)
            let intMM = parseInt(mm)
            let intYYYY = parseInt(yyyy)

            let newValue = ''

            if (event.code == 'ArrowUp' && this.$moment([intYYYY, intMM - 1, intDD]).isValid()) {
                event.preventDefault()

                this.lValue = this.$moment([intYYYY, intMM - 1, intDD])
                    .add('d', 1)
                    .format(this.format)

                this.month = this.$moment(this.lValue, this.format).startOf('month')

                return
            }

            if (event.code == 'ArrowDown' && this.$moment([yyyy, intMM - 1, dd]).isValid()) {
                this.lValue = this.$moment([yyyy, intMM - 1, dd])
                    .subtract('d', 1)
                    .format(this.format)

                this.month = this.$moment(this.lValue, this.format).startOf('month')
                return
            }

            // console.log([dd, mm, yyyy])

            if (dd != null && !isNaN(intDD)) {
                newValue += dd

                if (intDD > 3 || event.code == 'Slash' || !isNaN(mm) || dd.length == 2) {
                    newValue += '/'
                }
            }

            if (dd != null && mm != null && !isNaN(intMM)) {
                newValue += mm

                if (mm > 1 || event.code == 'Slash' || mm.length == 2 || !isNaN(yyyy)) {
                    newValue += '/'
                }
            }

            if (dd != null && mm != null && !isNaN(intMM) && yyyy != null && !isNaN(intYYYY)) {
                //     // console.log("yyyy", yyyy);
                //     // console.log("yyyy", String(yyyy).length);
                //     // console.log([yyyy != 20, String(yyyy).length == 2]);

                //     if (String(yyyy) != '20' && String(yyyy).length == 2) {
                //         yyyy = '20' + String(yyyy)
                //     }

                newValue += String(yyyy)
            }

            let test = this.$moment([yyyy, intMM - 1, dd])

            if (test.isValid() && String(yyyy).length == 4) {
                this.lValue = test.format(this.format)
                this.month = this.$moment(this.lValue, this.format).startOf('month')
            } else {
                this.lValue = newValue
            }

            // return newValue;
        },

        moveToTop() {
            // setTimeout(() => {
            //     let bounding = document.activeElement.getBoundingClientRect()
            //     console.log('this.$refs.keepInView.offsetTop', this.$refs.keepInView.offsetTop)
            //     console.log('new top', document.activeElement.getBoundingClientRect().top)
            //     window.scrollTo({
            //         top: this.$refs.keepInView.offsetTop,
            //         // top: document.activeElement.getBoundingClientRect().top,
            //         behavior: 'smooth',
            //     })
            // }, 0)
        },
    },

    computed: {
        dates() {
            let a = []
            let date = this.$moment(this.month).startOf('month')
            let days = this.$moment(date).daysInMonth()

            for (let i = 0; i < days; i++) {
                if (i == 0 && this.$moment(date).isoWeekday() != 1) {
                    for (let x = 1; x < this.$moment(date).isoWeekday(); x++) {
                        a.push({
                            date: -1,
                        })
                    }
                }

                let t = this.$moment(this.month).add(i, 'd')

                a.push({
                    date: t.format(this.format),
                    day: t.format('D'),
                    before: t.isBefore(this.$moment(this.minDate, this.format)),
                    after: t.isAfter(this.$moment(this.maxDate, this.format)),
                    today: t.isSame(this.$moment(), 'day'),
                })
            }

            return a
        },

        minDate() {
            if (this.min == null) {
                return false
            }

            if (typeof this.min === 'number') {
                return this.$moment().add(this.min, 'd').format(this.format)
            }

            if (typeof this.min === 'string') {
                return this.$moment(this.min).format(this.format)
            }
        },

        maxDate() {
            if (this.max == null) {
                return false
            }

            if (typeof this.max === 'number') {
                return this.$moment().add(this.max, 'd').format(this.format)
            }

            if (typeof this.max === 'string') {
                return this.$moment(this.max).format(this.format)
            }
        },

        error() {
            let inputForm = this.$help.getComponent(this, 'InputForm')

            return inputForm != null ? inputForm.$data.errors.has(this.errorName != false ? this.errorName : this.name) : false
        },

        // error() {
        // 	try {
        // 		return this.$help
        // 			.getComponent(this, "InputForm")
        // 			.$data.errors.has(this.name);
        // 	} catch (e) {
        // 		return false;
        // 	}
        // },
    },

    watch: {
        lValue() {
            this.$emit('change', this.lValue, this.format)
        },
        value() {
            // this was causing an error
            // this.lValue = this.$moment(this.value).format(this.format)
        },
    },
}
</script>
